import React, { useContext, useCallback } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import {
	IEditCategoryRestaurantPropertiesContext,
	EditCategoryRestaurantPropertiesContext,
} from '../../editCategoryRestaurantPropertiesState/editCategoryRestaurantPropertiesContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { SaveAsPatchModal } from './SaveAsPatchModal/index';
import { updateCategoryRestaurantProperties } from 'backend/categories';
import { useHistory } from 'react-router-dom';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, refetchRestaurantPropertiesData, dataForSubmit, typeOfModalWindow, categoryId } =
		useContext<IEditCategoryRestaurantPropertiesContext>(EditCategoryRestaurantPropertiesContext);
	const history = useHistory();

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateCategoryRestaurantProperties(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseSaveAsPatchModal = useCallback(() => {
		changeTypeOfModalWindow(null);
		refetchRestaurantPropertiesData(true);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={() => history.push(`/menu-v2/category/view?categoryID=${categoryId}`)}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'saveAsPatch' && <SaveAsPatchModal onCloseModal={handleCloseSaveAsPatchModal} />}
		</ModalWrapper>
	);
};
